var _style, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVehicleResource(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.5,14.5c-0.3,0-0.5,0.1-0.7,0.3s-0.3,0.4-0.3,0.7s0.1,0.5,0.3,0.7c0.2,0.2,0.4,0.3,0.7,0.3s0.5-0.1,0.7-0.3 c0.2-0.2,0.3-0.4,0.3-0.7s-0.1-0.5-0.3-0.7C19.1,14.6,18.8,14.5,18.5,14.5z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.9,13.4h0.9v-9h-12v3c1.1-0.6,2.3-0.9,3.5-0.9C11.3,6.5,14.6,9.6,14.9,13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.9,14.4c-0.3,0-0.5,0.1-0.7,0.3c-0.2,0.2-0.3,0.4-0.3,0.7s0.1,0.5,0.3,0.7c0.2,0.2,0.4,0.3,0.7,0.3 s0.5-0.1,0.7-0.3s0.3-0.4,0.3-0.7s-0.1-0.5-0.3-0.7S19.2,14.4,18.9,14.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "17.8,8.4 17.8,11.4 22,11.4 19.8,8.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20.8,6.4h-3v-4h-14c-0.5,0-1,0.2-1.4,0.6C2,3.4,1.8,3.8,1.8,4.4V9c0.6-0.6,1.2-1.2,2-1.6v-3h12v9h-0.9 c0,0.2,0,0.4,0,0.6c0,0.5,0,0.9-0.1,1.4h0.9c0,0.8,0.3,1.5,0.9,2.1c0.6,0.6,1.3,0.9,2.1,0.9c0.8,0,1.5-0.3,2.1-0.9 c0.6-0.6,0.9-1.3,0.9-2.1h2v-5L20.8,6.4z M19.6,16.1c-0.2,0.2-0.4,0.3-0.7,0.3s-0.5-0.1-0.7-0.3c-0.2-0.2-0.3-0.4-0.3-0.7 s0.1-0.5,0.3-0.7c0.2-0.2,0.4-0.3,0.7-0.3s0.5,0.1,0.7,0.3s0.3,0.4,0.3,0.7S19.8,15.9,19.6,16.1z M17.8,11.4v-3h2l2.2,3H17.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M3.7,17c0.5-0.4,1.1-0.7,1.7-0.9c0.6-0.2,1.3-0.3,2-0.3s1.4,0.1,2,0.3c0.6,0.2,1.2,0.5,1.7,0.9 c0.4-0.4,0.6-0.9,0.8-1.4s0.3-1.1,0.3-1.7c0-1.4-0.5-2.5-1.4-3.5S8.8,9,7.5,9S5,9.5,4,10.4s-1.4,2.1-1.4,3.5 c0,0.6,0.1,1.2,0.3,1.7C3.1,16.1,3.4,16.6,3.7,17z M7.5,14.5c-0.6,0-1.1-0.2-1.5-0.6c-0.4-0.4-0.6-0.9-0.6-1.5 c0-0.6,0.2-1.1,0.6-1.5c0.4-0.4,0.9-0.6,1.5-0.6c0.6,0,1.1,0.2,1.5,0.6c0.4,0.4,0.6,0.9,0.6,1.5c0,0.6-0.2,1.1-0.6,1.5 C8.6,14.3,8.1,14.5,7.5,14.5z M7.5,20c-0.8,0-1.6-0.2-2.4-0.5c-0.7-0.3-1.4-0.8-1.9-1.3s-1-1.2-1.3-1.9s-0.5-1.5-0.5-2.4 s0.2-1.6,0.5-2.4s0.8-1.4,1.3-1.9c0.6-0.6,1.2-1,1.9-1.3c0.7-0.3,1.5-0.5,2.4-0.5c0.8,0,1.6,0.2,2.4,0.5c0.7,0.3,1.4,0.8,1.9,1.3 c0.6,0.6,1,1.2,1.3,1.9s0.5,1.5,0.5,2.4s-0.2,1.6-0.5,2.4s-0.8,1.4-1.3,1.9c-0.6,0.6-1.2,1-1.9,1.3C9.1,19.9,8.3,20,7.5,20z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicleResource);
export default __webpack_public_path__ + "static/media/vehicle-resource.104fd08c5c1ff19ad519f70b72a0fd97.svg";
export { ForwardRef as ReactComponent };